export const habaProduct = {
  habaProductCard: {
    newTag: 'New',
    sustainableTag: 'Sustainable',
    bestsellerTag: 'Bestseller',
    saleTag: 'Sale',
    color: 'Colors',
    from: 'from',
    configurable: 'configurable',
    configurableDetails: 'This product is configurable, which may change the actual price.',
    priceListTextDesktop: '<b>List Price</b>',
    priceListTextMobile: '<b>List price.</b>',
    chooseSize: 'Choose size',
    aiImageAlt: 'AI-generated image',
  },
  habaProductDetails: {
    additionalInformation: 'Additional Information (PDF-Download)',
    addToCart: 'Add to cart',
    addToCartShort: 'Add',
    addToCartFinished: 'Added',
    disabled: 'Currently not available for order',
    openConfigurator: 'Configure now',
    openConfiguratorFromProductCard: 'Configure',
    deliveryDetails: 'Delivery Details',
    from: 'from',
    downloadCertificate: 'Download certificate:',
    quantity: 'Quantity',
    descriptionMoreLink: 'More',
    descriptionHeadline: 'Product Description',
    productLine: {
      warrantyUnit: 'Years',
      warrantyCaption: 'Warranty',
      moreLink: 'Learn more',
      comfort: {
        headline: 'Our Comfort Line',
        badge: 'Comfort',
        warrantyYears: '5',
        moreLinkUrl:
          '/inspiration-knowledge/product-worlds/professional-and-comfort#wehrfritz-comfort',
        description:
          'The <b>Wehrfritz Comfort product line</b> impresses with an attractive price-performance ratio that harmoniously combines quality and functionality.',
      },
      professional: {
        headline: 'Our Professional Line',
        badge: 'Professional',
        warrantyYears: '10',
        moreLinkUrl:
          '/inspiration-knowledge/product-worlds/professional-and-comfort#wehrfritz-professional',
        description:
          'The <b>Wehrfritz Professional product line</b> stands for the highest quality, functionality and a variety that leaves nothing to be desired. With certified safety standards, durable materials and a warranty of up to 10 years, this line sets the benchmark.',
      },
    },
    vat: 'incl. VAT',
    taxDelivery: 'plus shipping or freight costs',
    outOfStock: 'Out of stock',
    instructions: 'Material & Care Instructions',
    pdfDownloads: 'More Information (Download)',
    certificates: 'Certificates / Badges',
    energyLabelLinkText: 'Product data sheet',
    listPriceMessage: '<strong>List Price</strong>',
    listPrice: '<strong>List Price</strong>',
    strikethroughPriceMessage: '<strong>Promotional Price</strong>',
    strikethroughPriceMessageEndOfLife: '<strong>Clearance price</strong>',
    customerSpecificPriceMessage: '<strong>Your Price,</strong> incl.',
    customerSpecificPriceMessageShort: '<strong>Your Price</strong>',
    reduction: 'discount',
    classifications: {
      qs: {
        headline: 'Warning information',
        sub: {
          h_saetze: 'H-phrases',
          ghssymbolundsignalwort: 'GHS symbol and signal word',
          warnhinweise: 'information',
        },
      },
      stoffartikel: {
        headline: 'Material & care instructions',
      },
      moebelartikel: {
        headline: 'Ordering information',
      },
    },
    note: 'Note',
    information: {
      moreInformation: {
        headline: 'More information',
      },
      certifactes: {
        headline: 'Certificates',
        label: 'Download certificate',
      },
      qaWarnings: {
        headline: 'Warnings',
      },
      qaGHS: {
        headline: 'GHS symbol and signal word',
      },
      qaSafety: {
        headline: 'Safety instructions',
      },
      qaCare: {
        headline: 'Material & care instructions',
      },
      qaHSentence: {
        headline: 'H-phrases',
      },
    },
    certificate: {
      certifiedBy: 'Certified by',
      licenceNumber: 'Licence Number',
    },
    manufacturer: 'Manufacturer',
    pleaseSelectAmount: 'Please select an amount:',
    selectIndividualAmount: 'Or select an individual amount:',
    amountInfo: 'Only amounts without decimal places are allowed.',
    enterAmount: 'Enter amount',
    amountConfirm: 'Confirm',
    selectedVoucherValue: 'Selected voucher value',
    voucherValueAdjustedTitleSuccess: 'The voucher value has been adjusted',
    voucherValueAdjustedMessageSuccess: 'Now you just need to add it to the shopping cart',
    voucherValueAdjustedTitleError: 'Invalid input',
    voucherValueAdjustedMessageError:
      'The gift card value must be in a valid format without decimal places.',
    voucherIntervalValueAdjustedMessageError:
      'The selected gift voucher value must be between €10 and €500',
    freeDelivery: 'Free delivery',
    voucherReceiptInfo: '(Receipt may take a few minutes. Please also check your spam folder)',
    selectVoucherValue: 'Select voucher value',
    minimumPrice: {
      bestPrice: '30-day Best Price:',
      learnMore: 'Learn more',
      currentPriceIsTheLowestPrice:
        'The "30-day best price" is the lowest price at which the retailer offered this product in the 30 days prior to the last price change.',
      currentPriceIsNotTheLowestPrice:
        'The "30-day best price" is the lowest price at which the retailer offered this product in the 30 days prior to the last price change. Due to past discount campaigns, the "30-day best price" may be lower than the current price.',
      understood: 'I understand',
      modalTitle: 'Why is "Lowest price in the last 30 days" displayed?',
      modalParagraph1:
        'Due to new EU legislation, we have added "Lowest price in the last 30 days." This helps both us and our customers to be more transparent about product price changes in a timely manner.<br><br>For example, the lowest price of the product in the 30 days prior to the start of the new sales campaign (e.g., "Winter Sale") was 100.00 EUR. This price is listed as "Lowest price in the last 30 days" when we announce the first price reduction (e.g., 90.00 EUR) in the newly launched campaign. The "Lowest price in the last 30 days" remains the same throughout the campaign, even if there are further price reductions (e.g., 80.00 EUR, 70.00 EUR, etc.) within the same campaign.',
      modalTitle2: 'Why is "Lowest price in the last 30 days" displayed?',
      modalParagraph2:
        'According to the new EU price indication regulation, the so-called "previous price" applied by us is indicated for every communicated promotional campaign. What the legislator refers to as "previous price," we call "Lowest price in the last 30 days."',
      euLegislationLinkTitle:
        'For more information on the new EU price indication legislation, visit this website.',
      euLegislationLink:
        'https://commission.europa.eu/law/law-topic/consumer-protection-law/unfair-commercial-practices-and-price-indication/price-indication-directive_en',
    },
    availability: {
      green: 'In stock',
      yellow: 'Available soon',
      red: 'Sold out',
      configurable: 'Made to order',
      procureOnOrder: 'Procured after order',
    },
  },
  habaProductConfigurator: {
    messages: {
      success: 'Your item has been added to the shopping cart',
      error: 'Your item could not be added to the shopping cart',
    },
    isLoading: 'The product will be added to the cart. Please be patient.',
    delivery: 'Delivery in 9 - 11 weeks',
    cancelHint: 'Cancel configuration',
  },
  habaProductVariants: {
    color: 'Color',
    size: 'Size',
    sold: 'sold out',
  },
  habaProductConsultant: {
    product: 'Product',
    description: 'Description',
    price: 'Price',
    actions: 'Actions',
    suggestions: 'Product suggestions',
    totalPriceText: 'Total price for complete equipment:',
  },
};
